import './FormError.scss';

import React from 'react';

export default class FormError extends React.Component {
    static propTypes = {
        show: React.PropTypes.bool.isRequired
    };

    render() {
        if(this.props.show === true) {
            return (
                <div className="form-row form-error-message">
                    {this.props.children}
                </div>
            );
        } else {
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/FormError/index.js